import { emailConfig } from '../config/emailConfig';

export const withRetry = async <T>(
  fn: () => Promise<T>,
  maxRetries: number = emailConfig.maxRetries
): Promise<T> => {
  let lastError: Error;
  
  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      return await fn();
    } catch (error) {
      lastError = error as Error;
      if (attempt === maxRetries) break;
      
      await new Promise(resolve => 
        setTimeout(resolve, emailConfig.retryDelay * attempt)
      );
    }
  }
  
  throw lastError!;
};